<template>
  <div>
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('2')"></h5>
      </legend>
    </div>

    <form-v2-oeap-scopes-table
      :activity="activity"
      v-if="activity && status"
      :disabled="disabled"
      :status="status"
      :title="$store.getters.getTag('3.T')"
      :subtitle="$store.getters.getTag('3.S')"
      :footer="$store.getters.getTag('3.F')"
    />

    <p class="col-12 mt-4" v-html="$store.getters.getTag('3.I.1')"></p>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      if (["100"].includes(this.status)) {
        return false;
      } else if (["112"].includes(this.status)) {
          if (this.$store.state.accreditation.app.change_scopes) {
            return false;
          } else {
            return true;
          } 
      } else {
        return true;
      }
    },
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = {
        id: data.id,
        scope_check_1: data.scope_check_1,
      };
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;
      this.axiosGet(
        `/accreditations/applications/form/${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = {
              id: response.data.id,
              scope_check_1: response.data.scope_check_1,
            };
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
